

export class Address{
    PostalCode:string;
    City:string;
    State:string;
    Country:string;
    Direction:string;
}